export const setProducts = (products) => ({
  type: "SET_PRODUCTS",
  payload: products,
});

export const setActiveProduct = (product) => ({
  type: "SET_ACTIVE_PRODUCT",
  payload: product,
});
